import React from "react";
import styled from "styled-components";

const Use = () => {
    
const Title = styled.div`
    color: #191919;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    margin-top: 10px;
    margin-left: 30px;
`;
const Date = styled.div`
    color: #8F8F8F;
    font-family: Pretendard;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 180% */
    margin-top: 10px;
    margin-left: 30px;
`;

const Container = styled.div`
    padding:10px
`

const Energy = styled.div`
color: #EAAF00;
text-align: right;
font-family: Pretendard;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 112.5% */
width: 59.079px;
margin-left: auto;
margin-top: -30px;
`;

  return (
    <>
        <Container>
        <Title>[사용] 지쿠 1일 이용권 쿠폰 발급씽씽 10% 할인 쿠폰 발급</Title>
        <Date>2023-11-12</Date>
        <Energy>-20E</Energy>
        </Container>
        <Container>
        <Title>[사용] 씽씽 10% 할인 쿠폰 발급</Title>
        <Date>2023-11-13</Date>
        <Energy>-10E</Energy>
        </Container>

    </>
  );

};


export default Use;
